import { ProviderEventType } from '../types/enums/ProviderEventType';
import { ProviderEvent } from '../models/ProviderEvents';

export class WithListener {
	listeners: Partial<
		Record<ProviderEventType, Array<(event: ProviderEvent) => void>>
	> = {};
	on = <C extends ProviderEvent>(
		eventType: ProviderEventType,
		callback: (event: C) => void,
	) => {
		this.listeners = {
			...this.listeners,
			[eventType]: [...(this.listeners[eventType] ?? []), callback],
		};
		return () => {
			this.listeners = {
				...this.listeners,
				[eventType]: this.listeners[eventType]?.filter(
					(listener) => listener !== callback,
				),
			};
		};
	};
	notify = (event: ProviderEvent) => {
		this.listeners[event.type]?.forEach((callback) => {
			callback(event);
		});
	};
}
